import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router';
import { Box } from '@mui/material';

import appdata from '../../Services/appdata';
import Settings from '../Settings';
import Reporting from '../Reporting';
import Strategy from '../Strategy';
import MainPage from '../MainPage';
import Admin from '../Admin';
import ManageTempDB from '../ManageTempDB';
import PackageManagement from '../PackageManagement';
import band from '../../Assets/image/band.png';
import bandSymbol from '../../Assets/image/band-symbol.png';
import './style.css';

const Home = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    const user = appdata.getItem('user');
    if (user === null) {
      navigate('/login');
    } else {
      setIsLoggedIn(true);
      if (user.is_admin) {
        navigate('/home/admin');
      }
    }

    if (user && user.is_admin) {
      let adminRoutes = [];
      adminRoutes.push(
        <Route path="admin" element={<Admin />} key={adminRoutes.length} />,
      );
      adminRoutes.push(
        <Route
          path="managetempdb"
          element={<ManageTempDB />}
          key={adminRoutes.length}
        />,
      );
      adminRoutes.push(
        <Route
          path="pkgmanage"
          element={<PackageManagement />}
          key={adminRoutes.length}
        />,
      );
      adminRoutes.push(
        <Route path="main" element={<MainPage />} key={adminRoutes.length} />,
      );
      setRoutes(adminRoutes);
      return;
    }

    addAccessAllPagesMenu();
  }, []);

  const addAccessAllPagesMenu = () => {
    let newRoutes = [];
    newRoutes.push(
      <Route
        path=""
        element={<Navigate reploace to="main" />}
        key={newRoutes.length}
      />,
    );
    newRoutes.push(
      <Route path="main" element={<MainPage />} key={newRoutes.length} />,
    );
    newRoutes.push(
      <Route path="strategy" element={<Strategy />} key={newRoutes.length} />,
    );
    newRoutes.push(
      <Route path="reporting/*" element={<Reporting />} key={newRoutes.length} />,
    );
    newRoutes.push(
      <Route
        path="reporting"
        element={<Navigate reploace to="intro" />}
        key={newRoutes.length}
      />,
    );
    newRoutes.push(
      <Route path="settings/*" element={<Settings />} key={newRoutes.length} />,
    );

    const role = appdata.getItem('role');
    if (role) {
      role.realAccess = role.accesses;
      appdata.setItem('role', role);
    }

    setRoutes(newRoutes);
  };

  return isLoggedIn ? (
    <Box
      sx={{
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
      }}
    >
      <main
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          padding: 0,
          minWidth: 0,
          minHeight: '100vh',
          overflow: 'auto',
        }}
      >
        <Routes>{routes}</Routes>
        <div className="footer-content">
          <img className="band-image" src={band} alt="band" />
          <img
            className="band-right-image"
            src={bandSymbol}
            alt="band-right"
          />
        </div>
      </main>
    </Box>
  ) : null;
};

export default Home;
